import { Box, Grid, Typography } from "@mui/material";
import { getStatFontSize } from "./statControlHelpers";

const StatControl = (props) => {
    let {
        rgbaOne,
        rgbaTwo,
        textHeader,
        colorOfSecondBlock,
        preStatDat,
        symbol,
        textFooter,
        CustomBox,
    } = props.prep
    const CheckedValueOnCard = preStatDat === "-" ? preStatDat : Math.round(preStatDat).toLocaleString('ru-RU')
    const fontSize = getStatFontSize(CheckedValueOnCard)

    return (
        <Grid item xl={4} lg={4} l={4} md={6} s={12} sm={12} xs={12} py={3}>
            <CustomBox elevation={6} sx={{ background: `linear-gradient(320deg, ${rgbaOne}, ${rgbaTwo} 100%)`, width: "100%" }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: '10px' }} elevation={3}>
                    {/* <DateRange color='emerald' sx={{ mr: 1 }} /> */}
                    {props.children}
                    <Typography variant="h2">{textHeader}</Typography>
                </Box>
                <Typography
                    sx={{
                        fontSize,
                        fontWeight: 700,
                        wordBreak: 'break',
                        paddingRight: "5px"
                    }}
                    color={colorOfSecondBlock}
                >
                    {CheckedValueOnCard}
                    <Typography component="span" variant="h3"> {symbol}</Typography>
                </Typography>
                <Typography variant="caption">{textFooter}</Typography>
            </CustomBox>
        </Grid>
    )
}

export default StatControl;